import { DragIndicator } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import {
  Avatar,
  AvatarGroup,
  Checkbox,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { Box, Stack } from '@mui/system';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import calendar from '../../../../icons/untitled-ui/duocolor/calendar-plus.svg';
import trash from '../../../../icons/untitled-ui/duocolor/trash.svg';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultSkillIcon } from 'src/pages/therapist-dashboard/dashboard-icon';
import { TaskTypeSvg } from './task-type-svg';
import { formatPatientData, getPayerCateGroup } from 'src/layouts/components/utils-method';
import { AddNoteIcon } from 'src/components/therapyPlanning_2.0/commonComponent/therapy-planning-icons';
import {
  getTherapistTaskNoteAction,
  resetCreateTherapistTaskNote,
} from 'src/redux/actions/therapySchedulingSkillList';
import { PencilIcon, PriorityHigh } from './schedule-icon';

type Props = {
  patient: any;
  handleToRescheduleTask: any;
  setTaskSelectedId: any;
  taskSelectedId: any;
  setOpenEditTimeDialog: any;
  setCurrentPatientTask?: any;
  setOpenTaskDeleteModal?: any;
  handleOpenTaskNote: any;
  setIsEditNote: any;
  setTherapyInfo: any;
};

const skillsList = [
  {
    skillName: 'Shower Transfers',
    icon: '/public/assets/skills-icon/Shower Task.svg',
  },
  {
    skillName: 'Don/Doff Socks',
    icon: '/public/assets/skills-icon/Don_Doff Socks.svg',
  },
  {
    skillName: 'Don/Doff Shoes',
    icon: '/public/assets/skills-icon/Don_Doff Shoes.svg',
  },
  {
    skillName: 'LB Dressing',
    icon: '/public/assets/skills-icon/LB Dressing.svg',
  },
  {
    skillName: 'UB Dressing',
    icon: '/public/assets/skills-icon/UB Dressing.svg',
  },
  {
    skillName: 'Shower Task',
    icon: '/public/assets/skills-icon/Shower Task.svg',
  },
  {
    skillName: 'Bathing Task',
    icon: '/public/assets/skills-icon/Bathing Task.svg',
  },

  {
    skillName: 'Medication Management',
    icon: '/public/assets/skills-icon/Medication Management.svg',
  },
  {
    skillName: 'Meal Prep',
    icon: '/public/assets/skills-icon/Meal Prep.svg',
  },
  {
    skillName: 'Financial Management',
    icon: '/public/assets/skills-icon/Financial Management.svg',
  },
  {
    skillName: 'Self-Feeding',
    icon: '/public/assets/skills-icon/Self Feeding.svg',
  },
  {
    skillName: 'Light Household Management',
    icon: '/public/assets/skills-icon/Light Household Management.svg',
  },
  {
    skillName: 'Bed Mobility',
    icon: '/public/assets/skills-icon/Bed Mobility.svg',
  },
  {
    skillName: 'Ambulation',
    icon: '/public/assets/skills-icon/Ambulation.svg',
  },
  {
    skillName: 'Wheelchair Mobility',
    icon: '/public/assets/skills-icon/Wheelchair Mobility.svg',
  },
  {
    skillName: 'Transfers',
    icon: '/public/assets/skills-icon/Transfers.svg',
  },
  {
    skillName: 'Oral Trials',
    icon: '/public/assets/skills-icon/Oral Trials.svg',
  },
  {
    skillName: 'Apraxia Tasks',
    icon: '/public/assets/skills-icon/Apraxia Tasks.svg',
  },
];

export const toCamelCase = (value: string): string => {
  if (!value) {
    return '';
  }

  return value
    .split(/[_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const TherapistTaskList = (props: Props) => {
  const {
    patient,
    handleToRescheduleTask,
    setTaskSelectedId,
    taskSelectedId,
    setOpenTaskDeleteModal,
    setCurrentPatientTask,
    handleOpenTaskNote,
    setIsEditNote,
  } = props;
  const skillsMapping = patient.skillName;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const getPayerPlanTypeResponse = useSelector(
    (state: any) => state.getPayerPlanTypeReducer?.enterprisePayerPlanType?.data
  );
  const getTherapistProfile = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );
  const providerId = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
  );
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const getTherapistSkillListResponse = useSelector(
    (state: any) => state?.getSkillsListReducer?.response?.data
  );
  const payerName =
    getPayerPlanTypeResponse &&
    getPayerPlanTypeResponse.find((payer: any) => payer.key === patient?.payerPlanType);
  const skills = skillsMapping?.map((skill: string, index: number) => {
    const skills = getTherapistSkillListResponse?.find(
      (skills: any) => skills?.skillName === skill
    );
    return {
      skill_name: skill,
      skill_image: skills?.skillImage,
    };
  });
  const handleSelect = (e: any, id: any, patientDetail: any) => {
    if (taskSelectedId.includes(id)) {
      const uuidArr = taskSelectedId.filter((item: any) => item !== id);
      setTaskSelectedId(uuidArr);
    } else {
      setTaskSelectedId((prev: any) => [...prev, id]);
    }
  };

  return (
    <Stack>
      <Box
        width={'100%'}
        display={'flex'}
        // justifyContent={'space-between'}
        gap={{ lg: 1, md: 1, sm: 1, xs: 1 }}
        alignItems={'center'}
      >
        <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <DragIndicator sx={{ marginLeft: '10px', color: '#7A7A7A', cursor: 'grab' }} />
          <Checkbox
            checked={taskSelectedId?.some((taskId: any) => taskId === patient?.uuid) ? true : false}
            onClick={(e) => handleSelect(e, patient.uuid, patient)}
          />
        </Stack>
        <Stack
          display={'flex'}
          flexDirection={'row'}
          // gap={{ lg: 0, md: 1, sm: 1, xs: 1 }}
          sx={{ width: '250px' }}
          gap="10px"
          padding={{ lg: '0', md: '10px 0px', sm: '10px 0px', xs: '10px 0px' }}
        >
          <Stack
            sx={{ width: '50%' }}
            justifyContent={'center'}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: { lg: 'auto', md: 'auto', xs: 'auto', sm: 'auto' },
              }}
            >
              <Stack gap="6px">
                <Tooltip
                  title={patient?.patientLastname + ', ' + patient?.patientFirstname}
                  placement="top-end"
                >
                  <Typography
                    sx={{
                      fontSize: '14px',
                      width: '120px',
                      color: '#111927',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontWeight: 500,
                      textAlign: 'left',
                      overflow: 'hidden',
                    }}
                  >
                    {patient?.patientLastname + ', ' + patient?.patientFirstname}
                  </Typography>
                </Tooltip>
                <Tooltip
                  title={
                    patient?.payerPlanName && patient?.planTracking
                      ? patient?.payerPlanName + ' - ' + patient?.planTracking
                      : patient?.payerPlanName
                      ? patient?.payerPlanName + '  - Non-PDPM'
                      : 'Non-PDPM'
                  }
                >
                  <Chip
                    variant="outlined"
                    size="small"
                    label={patient?.payerPlanName}
                    sx={{
                      color: '#111927',
                      fontFamily: 'Inter ',
                      fontSize: '10px ',
                      fontWeight: 500,
                      width: '125px',
                      height: '22px',
                      textAlign: 'left',
                      textOverflow: 'ellipsis',
                      borderRadius: '20px',
                      borderBottom: `2px solid ${getPayerCateGroup(patient?.payerPlanType)
                        ?.borderColor}`,
                      background: `${getPayerCateGroup(patient?.payerPlanType)?.bgColor}`,
                    }}
                  />
                </Tooltip>
              </Stack>
            </Box>
          </Stack>
          <Stack
            sx={{ width: '68%' }}
            gap="6px"
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                // width: { lg: 'auto', md: 'auto', xs: 'auto', sm: 'auto' },
                marginLeft: { lg: '20px', md: '10px', sm: '10px', xs: '10px' },
              }}
            >
              <TaskTypeSvg taskType={patient?.tasksType.replace('_', ' ')} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  marginLeft: { lg: '10px', md: '12px', sm: '22px', xs: '22px' },
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: 400, color: '#6C737F', textAlign: 'left' }}
                >
                  {toCamelCase(patient?.tasksType)}
                </Typography>
              </Box>
            </Box>
            <Box
              onClick={() => {
                props.setOpenEditTimeDialog(true);
                props.setTherapyInfo({
                  taskId: patient?.uuid,
                  therapyType: patient?.tasksType,
                  taskType: 'task-uuid',
                  numberOfMinutes: patient?.numberOfMinutes,
                  isAssigned: false,
                });
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                marginLeft: { lg: '22px', md: '12px', sm: '22px', xs: '22px' },
                gap: '5px',
              }}
            >
              {patient.overdue && <PriorityHigh />}
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  color: 'var(--secondary-main, #384250)',
                  lineHeight: '14px',
                  display: 'inline-block',
                }}
              >
                {patient?.numberOfMinutes} min
              </Typography>
              <PencilIcon />
            </Box>
          </Stack>
        </Stack>

        <Stack
          flexDirection={'row'}
          sx={{ position: 'absolute', right: '8px', gap: '8px' }}
        >
          <IconButton
            sx={{ padding: '0' }}
            onClick={() => setIsActive((prev: any) => !prev)}
          >
            {!isActive ? <KeyboardArrowDownOutlinedIcon /> : <KeyboardArrowUpOutlinedIcon />}
          </IconButton>
          <IconButton
            sx={{ padding: '0' }}
            onClick={handleClick}
          >
            <MoreVertRoundedIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
              onClick={() => {
                handleClose();
                handleToRescheduleTask(patient);
              }}
            >
              {' '}
              <img
                alt=""
                src={calendar}
              />
              Reschedule task
            </MenuItem>
            {/* <MenuItem
            sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
            onClick={() => {
              handleClose();
            }}
          >
            <img
              alt=""
              src={divide}
            />{' '}
            Split task mins
          </MenuItem> */}
            <MenuItem
              sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
              disabled={
                patient?.tasksType === 'GROUP_THERAPY' ||
                patient?.tasksType === 'THERAPY' ||
                patient?.tasksType === 'CONCURRENT'
              }
              onClick={() => {
                handleClose();
                setCurrentPatientTask(patient?.uuid);
                setOpenTaskDeleteModal(true);
              }}
            >
              {' '}
              <img
                alt=""
                src={trash}
              />
              Delete task{' '}
            </MenuItem>
            {getTherapistProfile?.currentRoles?.includes('dor') ? (
              <MenuItem
                sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
                onClick={() => {
                  dispatch(resetCreateTherapistTaskNote());
                  dispatch(
                    getTherapistTaskNoteAction({
                      providerId: providerId,
                      taskId: patient?.uuid,
                    })
                  );
                  setIsEditNote(patient?.noteAvailable);
                  setCurrentPatientTask(patient?.uuid);
                  handleClose();
                  handleOpenTaskNote();
                }}
              >
                {' '}
                <AddNoteIcon />
                {patient?.noteAvailable ? 'Edit a note' : 'Add note'}
              </MenuItem>
            ) : null}
          </Menu>
          {/* <Box
          sx={{
            display: 'flex',
            justifyContent: { lg: 'flex-end', md: 'flex-start' },
            maxWidth: '100px',
            marginRight: '16px',
            cursor: 'pointer',
            marginLeft: { lg: '0', md: '10px', sm: '10px', xs: '10px' },
          }}
          onClick={() => handleToRescheduleTask(patient)}
        >
         
        </Box> */}
        </Stack>
      </Box>
      {isActive && (
        <Stack
          // justifyContent="space-between"
          justifyContent="flex-start"
          flexDirection="row"
          flexWrap="wrap"
          gap={1}
          sx={{ marginLeft: '3.5rem', marginTop: '1rem' }}
        >
          <Stack
            sx={{
              justifyContent: 'center',
              // flex: 1,
              marginRight: '1.5rem',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                width: { lg: '140px', md: 'auto', xs: 'auto', sm: 'auto' },
                alignItems: 'center',
                marginLeft: { lg: '0', md: '45px', sm: '45px', xs: '45px' },
              }}
            >
              {!patient.overdue && patient && skills && skills.length > 0 ? (
                <AvatarGroup>
                  {skills.map((skill: any, index: number) => {
                    const isSkillsIconPresent =
                      skill?.skill_image && skill?.skill_image?.endsWith('svg');
                    let isIconPresent = null;
                    if (!isSkillsIconPresent) {
                      isIconPresent = skillsList?.find(
                        (skills) => skills?.skillName === skill?.skill_name
                      );
                    }

                    return (
                      <Tooltip title={skill?.skill_name}>
                        <Avatar
                          sx={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '64px',
                            border: ' 2px solid var(--background-paper, #FFF)',
                            background: 'var(--neutral-100, #F3F4F6)',
                          }}
                          key={index}
                        >
                          {isSkillsIconPresent ? (
                            <img
                              key={skill?.skill_name}
                              width="40px"
                              height="40px"
                              src={skill?.skill_image}
                              alt="not found"
                            />
                          ) : isIconPresent ? (
                            <img
                              key={isIconPresent?.icon}
                              width="40px"
                              height="40px"
                              src={isIconPresent?.icon}
                              alt="not found"
                            />
                          ) : (
                            <DefaultSkillIcon />
                          )}
                        </Avatar>
                      </Tooltip>
                    );
                  })}
                </AvatarGroup>
              ) : null}
            </Box>
          </Stack>
          <Stack
            sx={{
              justifyContent: 'center',
              marginRight: '1.5rem',
            }}
          >
            <Box
              sx={{
                display: { md: 'flex', lg: 'block', sm: 'flex', xs: 'flex' },
                alignItems: 'center',
                width: { lg: 'auto', md: 'auto', xs: 'auto', sm: 'auto' },
                marginLeft: { lg: '12px', md: '50px', sm: '50px' },
              }}
            >
              <Typography variant="captionText">Bed Assignment</Typography>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, textAlign: 'start' }}>
                {formatPatientData(
                  patient?.floorNumber,
                  patient?.roomNumber,
                  patient?.bedAssignment
                )}
              </Typography>
            </Box>
          </Stack>
          {/* <Stack
            sx={{
              justifyContent: 'center',
              marginRight: '1.5rem',
            }}
          >
            <Box
              sx={{
                display: { md: 'flex', lg: 'block', sm: 'flex', xs: 'flex' },
                alignItems: 'center',
                width: { lg: 'auto', md: 'auto', xs: 'auto', sm: 'auto' },
                marginLeft: { lg: '0', md: '50px', sm: '50px' },
              }}
            >
              <Typography variant="captionText">Planned/ Actual Therapy</Typography>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, textAlign: 'start' }}>
                {patient?.plannedActTherapy && patient?.plannedActTherapy}
                {/* 180/260 }
              </Typography>
            </Box>
          </Stack>
          <Stack
            sx={{
              justifyContent: 'center',
              marginRight: '1.5rem',
            }}
          >
            <Box
              sx={{
                display: { md: 'flex', lg: 'block', sm: 'flex', xs: 'flex' },
                alignItems: 'center',
                width: { lg: 'auto', md: 'auto', xs: 'auto', sm: 'auto' },
                marginLeft: { lg: '0', md: '50px', sm: '50px' },
              }}
            >
              <Typography variant="captionText">Eval. Therapists</Typography>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, textAlign: 'start' }}>
                {patient?.evalTherapist &&
                  patient.tasksType !== 'Evaluation' &&
                  patient?.evalTherapist}
                {/* Olivia Smith }
              </Typography>
            </Box>
          </Stack> */}
        </Stack>
      )}
    </Stack>
  );
};

export default TherapistTaskList;
